import Moment from "moment";
import React from "react";
import * as BS from "react-bootstrap";
import { connect } from "react-redux";
import { Link, match, RouteComponentProps, withRouter } from "react-router-dom";
import { push } from "react-router-redux";
import * as redux from "redux";
import * as Actions from "../../../actions";
import * as Comp from "../../../components";
import { Paths } from "../../../constants";
import { CareerCenterStatuses } from "../../../domain";
import * as M from "../../../models";
import { Api } from "../../../services/Api";
import { AppState } from "../../../store";
import { Utility } from "../../../utils";
import { CareerCenterHelper } from "../../../models/careerCenter/CareerCenterHelper";

const mapStateToProps = (state: AppState, ownProps: OwnProps | undefined): ConnectedState => ({
    api: new Api(state),
});

const mapDispatchToProps = (dispatch: redux.Dispatch<AppState>): ConnectedDispatch => ({
    goto: (url: string) => dispatch(push(url)),
    notifyError: (message: string, icon?: string) => dispatch(Actions.Noti.notifyError(message, icon)),
});

type OwnProps = RouteComponentProps<{
    guid: string;
}> & {
};

interface ConnectedState {
    api: Api;
}

interface ConnectedDispatch {
    goto: (url: string) => void;
    notifyError: (message: string, icon?: string) => void;
}

interface OwnState {
    errors: string[];
    resume?: M.CareerCenter.Resume;
}

type CombinedProps = ConnectedState & ConnectedDispatch & OwnProps;

class ResumeConfirmationComponent extends Comp.Base.BaseComponent<CombinedProps, OwnState> {

    public constructor(props: any) {
        super(props);
        this.state = {
            errors: [],
            loading: true,
        };
    }

    public async componentDidMount() {
        this._isMounted = true;

        const guid = this.props.match.params.guid;
        if (!guid) {
            this.setState({
                ...this.state,
                errors: ["Resume identifier is missing in URL (guid)"],
            });
            return;
        }

        const qp = { queryParams: { guid } };
        const result = await this.props.api.get<M.CareerCenter.Resume>(Api.endpoints.users.careerCenter.resume, qp);

        if (!this._isMounted)
            return;

        if (result.isSuccess && result.data) {
            if (result.data.statusId === CareerCenterStatuses.Created.id) {
                this.props.notifyError("The requested resume has not been posted yet.");
                this.props.goto(Paths.CareerCenter.Resume.Review + "/" + guid);
                return;
            }

            this.setState({
                ...this.state,
                resume: result.data,
            });
        }
        else {
            const errors =  M.Result.Result.errorsOrMessage(result);
            this.setState({
                ...this.state,
                errors,
            });
        }

        this.toggleLoading(false);
    }

    public componentWillUnmount() {
        this._isMounted = false;
    }

    public render() {
        let details = null;

        if (this.state.errors.length) {
            details = <BS.Alert bsStyle="warning">
                <h3>The requested resume could not be retrieved.</h3>
                <ul>
                    {this.state.errors.map((e, i) => (<li key={i}>{e.toString()}</li>))}
                </ul>
            </BS.Alert>;
        }
        else if (this.state.resume) {
            details = <Details resume={this.state.resume} routeMatch={this.props.match} />;
        }

        return <Comp.Page.PublicPage pageTitle="Resume post confirmation" style={{position: "relative", minHeight: "300px"}}>
            <Comp.Generic.LoadingSpinner show={this.state.loading} />
            {details}
        </Comp.Page.PublicPage>;
    }
}

export const ResumeConfirmation: React.ComponentClass<OwnProps> = connect(mapStateToProps, mapDispatchToProps)(withRouter(ResumeConfirmationComponent) as any);

interface DetailsProps {
    resume: M.CareerCenter.Resume;
    routeMatch: match<{}>;
}

const Details: React.SFC<DetailsProps> = (props) => {
    const resume = props.resume;
    const detailsUrl = `${CareerCenterHelper.resumeDetailsLink(resume)}`;
    const expiresOn = Utility.utcToLocal(Utility.fromApiDate(resume.expiresOn) || new Date());
    const confNumber = Utility.padText(resume.id.toString(), "0", 6);

    return <div>
            <h1>Confirmation</h1>
            <h2>Your CV/Resume has been posted!</h2>
            <p>
                Confirmation #{confNumber}. A confirmation email was sent to <strong>{resume.postedBy.username}</strong>
                <br /><br />
                Listing expires <strong>{Moment(expiresOn).format("MMMM D, YYYY")}</strong>.
                You will receive an email notification 10 days prior to expiration with the option to renew.
                <br />You may deactivate or edit your listing anytime via <Link to={Paths.User.CareerCenter.Resumes}>Your Profile</Link>.
            </p>

            <h2><Link to={detailsUrl}>View your CV/Resume &raquo;</Link></h2>

            <h2><Link to={Paths.CareerCenter.JobDirectory}>View job listings &raquo;</Link></h2>
        </div>;
};



// WEBPACK FOOTER //
// ./src/containers/careerCenter/resumeConfirmation/ResumeConfirmation.tsx